import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { RolesAndPermissionsPage } from '@/features/access-control/roles-and-permissions-page'

// The page's tab lives in the URL. Without `?tab` (or with an unknown value) the page
// opens on Roles, as it always has. /members and /permission-matrix redirect here.
const rolesSearchSchema = z.object({
  tab: z.enum(['roles', 'members', 'matrix']).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/roles'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  validateSearch: rolesSearchSchema,
  component: RolesAndPermissionsPage,
})
